<ng-container *ngIf="state$ | async as state">
    <kendo-dialog (close)="onDialogClose()"
        [title]="state?.ts ? ('prev-ts-dialog.title' | t7e:'Előző napi TS') + ':  ' + (state?.ts?.startdate | date: dateFormat) + '  -  ' + (state?.ts?.usname || '') : ('prev-ts-dialog.title' | t7e:'Előző napi TS')"
        [height]="'90vh'" [minWidth]="600">
        <div class="prev-ts-dialog">
            <div class="" *ngIf="state?.isLoading">
                <mat-spinner [diameter]="25"></mat-spinner>
                {{ 'prev-ts-dialog.loading-text' | t7e:'Az előző bevitt nap time sheetje töltődik. Egy kis türelmet kérünk...' }}
            </div>
            <div class="text-center !k-bg-info !k-text-light py-05 px-2 mt-2 prev-ts-empty" *ngIf="!state?.isLoading && state?.ts === null">
                <div class="prev-ts-empty-text">{{ 'prev-ts-dialog.empty-text' | t7e:'Nincs elérhető előző napi TS' }}</div>
            </div>
            <app-edit-timesheet [timesheet]="state?.ts ?? null"
                [layout]="'grid-form'" [showContract]="false"
                *ngIf="!state?.isLoading && state?.ts">
            </app-edit-timesheet>

            <div class="prev-ts-load-error text-center py-05" *ngIf="state?.error">
                {{ state.error }}
            </div>
        </div>
    </kendo-dialog>
</ng-container>
